import { useEffect, useState } from "react";
import styled from "styled-components";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { MediaCollection } from "api/media-library";
import { getSelectedCollection } from "selectors/mediaLibrarySelectors";
import { useSelector } from "react-redux";

interface Props {
  collections: Array<MediaCollection>;
  selectedCollection: MediaCollection | null;
  className?: string;
  disabled?: boolean;
  menuPlacement?: "bottom" | "top" | "auto";
  onChange(value: string | string[]): void;
  isMulti?: boolean;
}

function CollectionSelectorComponent(props: Props) {
  const historicSelectedCollection = useSelector(getSelectedCollection);
  const [currentSelectedCollection, setCurrentSelectedCollection] = useState(
    props.selectedCollection?._id || historicSelectedCollection?._id || null
  );
  useEffect(() => {
    if (
      props.selectedCollection?._id &&
      props.selectedCollection?._id !== currentSelectedCollection
    ) {
      setCurrentSelectedCollection(props.selectedCollection?._id);
    }
  }, [props.selectedCollection?._id, currentSelectedCollection]);

  const handleChange = (collectionId: string) => {
    setCurrentSelectedCollection(collectionId);
    props.onChange(collectionId);
  };

  const selectedCollection = props.collections.find(
    (c) => c._id === currentSelectedCollection
  );

  return (
    <Select
      value={currentSelectedCollection || undefined}
      onValueChange={handleChange}
      disabled={props.disabled}
    >
      <SelectTrigger className={props.className || ""}>
        <SelectValue placeholder="Select a collection…">
          {selectedCollection && (
            <ColoredItem color={selectedCollection?.preferences?.color}>
              {selectedCollection.name}
            </ColoredItem>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {props.collections.map((collection) => (
          <SelectItem key={collection._id} value={collection._id}>
            <ColoredItem color={collection?.preferences?.color}>
              {collection.name}
            </ColoredItem>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export const ColoredItem = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;

  &:before {
    display: block;
    content: "";
    width: 9px;
    height: 9px;
    border-radius: 15%;
    background-color: ${(props) => props.color ?? `rgb(204, 204, 204)`};
    margin-right: 10px;
  }
`;

export const CollectionSelector = styled(CollectionSelectorComponent)`
  .select__placeholder {
    // on small screens we need to reduce line-height so that
    // it doesn't overflow the container
    line-height: 14px;
  }
`;
